export default "__VITE_PUBLIC_ASSET__a9a44f73__"